import axios from 'axios';
import { GETSEODATA } from '../index';

export const getSeoDataApi = (postData) => {
  return axios.post(GETSEODATA, JSON.stringify(postData));
};
